var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('div',[_c(_vm.component,{tag:"component",attrs:{"tab-key":_vm.tabKey}})],1):_c('div',[_c('div',{staticClass:"d-flex justify-center align-center pa-6"},[_c('Loader')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }